export const LOCALES = ['de', 'en'] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'de';

/** Texts below a key path: `hr.absences.title` is `{ hr: { absences: { title } } }`. */
export type MessageTree = { readonly [key: string]: string | MessageTree };

/**
 * The text of `key` with its `{{placeholders}}` filled, or `undefined` if the tree has none.
 * For texts outside the browser, e.g. e-mails; the browser uses i18next.
 */
export function translate(
  tree: MessageTree,
  key: string,
  params: Readonly<Record<string, string | number>> = {},
): string | undefined {
  let node: string | MessageTree | undefined = tree;
  for (const segment of key.split('.')) {
    if (typeof node !== 'object' || !Object.hasOwn(node, segment)) return undefined;
    node = node[segment];
  }
  if (typeof node !== 'string') return undefined;
  return node.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name: string) =>
    Object.hasOwn(params, name) ? String(params[name]) : '',
  );
}
